<template>
    <div
        v-if="isShowing"
        ref="interactElement"
        :class="{
            isAnimating: isInteractAnimating,
            isCurrent: isCurrent,
        }"
        class="card"
        :style="{ transform: transformString }"
    >
        <h3 class="cardTitle">{{ title }}</h3>
        <h2
            class="love stamp"
            :class="{ visible: draggedDirection === 'cardAccepted' }"
        >
            <span>😍😍😍</span>
        </h2>
        <h2
            class="maybe stamp"
            :class="{ visible: draggedDirection === 'cardMaybe' }"
        >
            <span>Maybe</span>
        </h2>
        <h2
            class="notyet stamp"
            :class="{ visible: draggedDirection === 'cardRejected' }"
        >
            <span>Not yet...</span>
        </h2>
        <md-icon class="close">close</md-icon>
        <span class="stat" v-if="subtitle">{{ subtitle }}</span>
    </div>
</template>

<style scoped lang="less">
.close {
    position: absolute;
    top: 20px;
    right: 20px;
    color: rgba(255,255,255,.3) !important;
}
.stat {
    position: absolute;
    left: 20px;
    bottom: 30px;
    right: 20px;
    font-size: 10px;
    font-weight: normal;
    // text-transform: uppercase;
    line-height: 1em;
    text-align: center;

}
.stamp {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;

    font-size: 57px;
    line-height: 57px;
    text-transform: uppercase;
    opacity: 0;
    transition: 0.2s linear opacity;
    transition-delay: 0.5s;

    &.visible {
        opacity: 1;
    }

    &.notyet {
        color: rgb(255, 104, 129);
        span {
            // background: rgba(0, 0, 0, 0.4);

            border-color: rgb(255, 104, 129);
        }
    }

    span {
        padding: 10px;
        border: 7px solid white;
        border-radius: 20px;
        background: rgba(0, 0, 0, 0.3);
        transform: rotate(-20deg);
    }
}
</style>

<script>
import interact from 'interact.js'
const ACCEPT_CARD = 'cardAccepted'
const REJECT_CARD = 'cardRejected'
const SKIP_CARD = 'cardSkipped'
const MAYBE_CARD = 'cardMaybe'

export default {
    static: {
        interactMaxRotation: 15,
        interactOutOfSightXCoordinate: window.innerWidth,
        interactOutOfSightYCoordinate: window.innerHeight,
        interactYThreshold: window.innerWidth / 4,
        interactXThreshold: window.innerWidth / 4,
    },

    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
        },
        isCurrent: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            isShowing: true,
            isInteractAnimating: true,
            isInteractDragged: null,
            draggedDirection: null,
            interactPosition: {
                x: 0,
                y: 0,
                rotation: 0,
            },
        }
    },

    computed: {
        transformString() {
            if (!this.isInteractAnimating || this.isInteractDragged) {
                const { x, y, rotation } = this.interactPosition
                return `translate3D(${x}px, ${y}px, 0) rotate(${rotation}deg)`
            }

            return null
        },
    },

    mounted() {
        const element = this.$refs.interactElement

        interact(element).draggable({
            onstart: () => {
                this.isInteractAnimating = false
            },

            onmove: event => {
                const {
                    interactMaxRotation,
                    interactXThreshold,
                    interactYThreshold,
                } = this.$options.static
                const x = this.interactPosition.x + event.dx
                const y = this.interactPosition.y + event.dy

                let rotation = interactMaxRotation * (x / interactXThreshold)

                if (rotation > interactMaxRotation)
                    rotation = interactMaxRotation
                else if (rotation < -interactMaxRotation)
                    rotation = -interactMaxRotation

                if (x > interactXThreshold) {
                    this.draggedDirection = ACCEPT_CARD
                } else if (x < -interactXThreshold) {
                    this.draggedDirection = REJECT_CARD
                } else if (y > interactYThreshold) {
                    this.draggedDirection = MAYBE_CARD
                } else {
                    this.draggedDirection = undefined
                }

                this.interactSetPosition({ x, y, rotation })
            },

            onend: () => {
                const { x, y } = this.interactPosition
                const {
                    interactXThreshold,
                    interactYThreshold,
                } = this.$options.static
                this.isInteractAnimating = true

                if (x > interactXThreshold) this.playCard(ACCEPT_CARD)
                else if (x < -interactXThreshold) this.playCard(REJECT_CARD)
                else if (y > interactYThreshold) this.playCard(MAYBE_CARD)
                // else if (y < -interactYThreshold) this.playCard(SKIP_CARD)
                else this.resetCardPosition()
            },
        })
    },

    beforeDestroy() {
        interact(this.$refs.interactElement).unset()
    },

    methods: {
        hideCard() {
            setTimeout(() => {
                this.isShowing = false
                this.$emit('hideCard', this.title)
            }, 300)
        },

        playCard(interaction) {
            const {
                interactOutOfSightXCoordinate,
                interactOutOfSightYCoordinate,
                interactMaxRotation,
            } = this.$options.static

            this.interactUnsetElement()

            switch (interaction) {
                case ACCEPT_CARD:
                    this.interactSetPosition({
                        x: interactOutOfSightXCoordinate,
                        rotation: interactMaxRotation,
                    })
                    this.$emit(ACCEPT_CARD)
                    break
                case REJECT_CARD:
                    this.interactSetPosition({
                        x: -interactOutOfSightXCoordinate,
                        rotation: -interactMaxRotation,
                    })
                    this.$emit(REJECT_CARD)
                    break
                case SKIP_CARD:
                    this.interactSetPosition({
                        y: -interactOutOfSightYCoordinate,
                    })
                    this.$emit(SKIP_CARD)
                    break
                case MAYBE_CARD:
                    this.interactSetPosition({
                        y: interactOutOfSightYCoordinate,
                    })
                    this.$emit(MAYBE_CARD)
                    break
            }

            this.hideCard()
        },

        interactSetPosition(coordinates) {
            const { x = 0, y = 0, rotation = 0 } = coordinates
            this.interactPosition = { x, y, rotation }
        },

        interactUnsetElement() {
            interact(this.$refs.interactElement).unset()
            this.isInteractDragged = true
        },

        resetCardPosition() {
            this.interactSetPosition({ x: 0, y: 0, rotation: 0 })
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

$cardsTotal: 3;
$cardsWidth: 300px;
$cardsPositionOffset: 55vh * 0.06;
$cardsScaleOffset: 0.08;
$defaultTranslation: $cardsPositionOffset * $cardsTotal;
$defaultScale: 1 - ($cardsScaleOffset * $cardsTotal);
$fs-card-title: 1.125em;

.card {
    @include card();
    @include absolute(0);
    @include sizing(100% 80vw);
    @include flex-center();

    @include after() {
        @include sizing(21px 3px);
        @include absolute(right 0 bottom 11px left 0);

        margin: auto;
        border-radius: 100px;
        background: rgba($c-black, 0.3);
    }

    display: flex;
    max-height: calc(100vh - 15vw - 15vw - 80px);
    margin: auto;
    font-size: $fs-h2;
    line-height: 1.1em;
    font-weight: 300;
    h3 {
        font-weight: 100;
    }
    // font-weight: $fw-bold;
    // font-family: 'Roboto Slab', serif;

    color: $c-white;
    // background-image: linear-gradient(
    //     -180deg,
    //     $primary-gradient-start 2%,
    //     $primary-gradient-end 100%
    // );
    background-image: linear-gradient(to bottom right, #F6628D, #F584AF);
    opacity: 0;
    transform: translateY($defaultTranslation) scale($defaultScale);
    transform-origin: 50%, 100%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    user-select: none;
    pointer-events: none;
    will-change: transform, opacity;

    height: 100vh;

    padding: 20px;

    &.isCurrent {
        pointer-events: auto;
    }

    &.isAnimating {
        transition: transform 0.7s $ease-out-back, color 0.7s $ease-out-back;
    }
}

.cardTitle {
    margin: 0 0 15px;
    font-size: $fs-card-title;
}

@for $i from 1 through $cardsTotal {
    $index: $i - 1;
    $translation: $cardsPositionOffset * $index;
    $scale: 1 - ($cardsScaleOffset * $index);

    .card:nth-child(#{$i}) {
        z-index: $cardsTotal - $index;
        opacity: 1;
        transform: translateY($translation) scale($scale);

        @if $i == 3 {
            color: $c-red-25;
            background-color: $c-red-25;
        } @else if $i == 2 {
            color: rgba(255,255,255,.3);
            background-image: linear-gradient(to bottom right, rgb(223, 88, 126), rgb(179, 95, 127));
        }

        @if $i != 1 {
            // background-image: none;

            @include after() {
                @include sizing(0 0);
            }
        }
    }
}
</style>
